import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {AuthService} from '../auth/auth.service';
import {HomeService} from 'src/app/services/home/home.service';
import {NzNotificationService} from 'ng-zorro-antd/notification';
import {FormBuilder} from '@angular/forms';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {debounceTime, distinctUntilChanged, switchMap, takeUntil} from 'rxjs/operators';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {
  unsubscribe$ = new Subject<void>();
  page = 1;
  pageSize = 50;
  query;
  loading;
  businesses = [];
  form = this.fb.group({
    key: ''
  });
  searchChange$ = new BehaviorSubject('');

  constructor(
    private  authService: AuthService,
    private router: Router,
    private homeService: HomeService,
    private notification: NzNotificationService,
    private fb: FormBuilder,
  ) {
    this.loading = true;
    this.searchChange$.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      takeUntil(this.unsubscribe$),
      switchMap(value => {
        const query = {
          page: this.page,
          page_size: this.pageSize,
          keyword: value.trim()
        };
        return this.homeService.list(query);
      }),
    ).subscribe(
      res => {
        this.loading = false;
        if (res.code === 1) {
          this.businesses = res.data.items;
          return;
        } else {
          this.notification.create(
            'error',
            'Lấy danh sách danh nghiệp thất bại',
            res.message
          );
        }
      },
      error => {
        this.loading = false;
        this.notification.create(
          'error',
          'Lấy danh sách doanh nghiệp thất bại',
          'Hệ thống đang nâng cấp.Vui lòng thử lại sau'
        );
      }
    );
  }

  ngOnInit() {
    this.notification.config({
      nzPlacement: 'bottomRight',
      nzDuration: 1500
    });
    const currentUser = this.authService.currentUserValue;
    if (!currentUser.isAdmin) {
      this.notification.error(
        'Thất bại',
        'Tài khoản của bạn không có quyền truy cập vào trang này'
      );
      this.router.navigate(['/business/dashboard']);
      return;
    }
  }

  searchBusiness(event) {
    this.loading = true;
    this.searchChange$.next(event);
  }

  selectedBusiness(id) {
    this.homeService.select(id).subscribe(
      res => {
        if (res.code === 1) {
          this.router.navigate(['/business/dashboard']);
          return;
        }
        this.notification.create(
          'error',
          'Chọn tài khoản thất bại',
          res.message
        );
      },
      error => {
        this.notification.create(
          'error',
          'Chọn tài khoản thất bại',
          'Hệ thống đang nâng cấp.Vui lòng thử lại sau'
        );
      }
    );
  }

  logOut() {
    this.authService.logout();
    this.notification.create(
      'success',
      'Thành công',
      'Đăng xuất thành công'
    );
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
